import { useState } from "react";
import validateEmail from "../../helperFunctions/validateEmail";
import { Card, Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeSlash, faEye } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";

export default function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [validated, setValidated] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const navigate = useNavigate();

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    const emailData = event.currentTarget.firstChild.firstChild.value;
    setEmailError(validateEmail(emailData));

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if (form.checkValidity() === true) {
      event.preventDefault();
      // there should be a check here to see if the user needs 2fa
      navigate(`/login-2fa`);
    }
  };
  return (
    <>
      <Card.Title>Portal Login</Card.Title>
      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
        className="login-form"
      >
        <Form.Group controlId="validationEmail" className="form-group">
          <Form.Control
            required
            type="email"
            placeholder=""
            name="email"
            onChange={validateEmail}
            className="input"
          />
          <Form.Control.Feedback type="invalid">
            <strong>*{emailError}</strong>
          </Form.Control.Feedback>
          <Form.Label>Email</Form.Label>
        </Form.Group>

        <Form.Group
          controlId="validationPassword"
          className="form-group password-input"
        >
          <FontAwesomeIcon
            className="show-password"
            icon={showPassword ? faEyeSlash : faEye}
            onClick={handleClickShowPassword}
            onMouseDown={handleMouseDownPassword}
          />
          <Form.Control
            required
            type={showPassword ? "text" : "password"}
            placeholder=""
            name="password"
            className="input"
          />
          <Form.Control.Feedback type="invalid">
            <strong>*required field</strong>
          </Form.Control.Feedback>
          <Form.Label className="form-label">Password</Form.Label>
        </Form.Group>
        <Link className="forgot-password" to="/forgot-password">
          Forgot Password?
        </Link>

        <Button type="submit" className="sign-in-button">
          Sign In
        </Button>
      </Form>
    </>
  );
}
